<template>
    <div>
        <div v-if="$root.loading" class="loading">در حال بارگذاری...</div>
        <div v-for="comment in comments" class="border-bottom" :id="'comment-' + comment.id">
            <div class="row no-gutters comment">
                <div class="col-xx-2 col-el-2 col-xl-2 col-lg-2 col-md-2 col-sm-3 col-tm-3 col-12 border-left-1">
                    <div class="text-center p-2">

                        <template v-if="comment.avatar.s === 'admin'">
                            <div class="avatar avatar-image" :style="'background-image:url(' + $root.baseURL + 'images/hadi-pourabbas.png)'"></div>
                        </template>
                        <template v-else>
                            <div class="avatar" :style="'background:' + comment.avatar.c">{{ comment.avatar.s }}</div>
                        </template>

                        <div class="comment-name">{{ comment.name }}</div>
                        <div class="comment-date num-fa">
                            <i class="fa fa-calendar"></i>
                            {{ comment.created_at }}
                        </div>
                    </div>
                </div>
                <div class="col-xx-10 col-el-10 col-xl-10 col-lg-10 col-md-10 col-sm-9 col-tm-9 col-12 comment-text">
                    <div>
                        <pre :class="['text p-2', (comment.child ? 'border-bottom-1' : '')]" v-html="comment.text"></pre>
                        <div v-if="comment.child" class="row no-gutters comment">
                            <div class="col-xx-2 col-el-2 col-xl-2 col-lg-2 col-md-2 col-sm-3 col-tm-12 col-12 border-left-1">
                                <div class="text-center p-2">

                                    <template v-if="comment.child.avatar.s === 'admin'">
                                        <div class="avatar avatar-image" :style="'background-image:url(' + $root.baseURL + 'images/hadi-pourabbas.png)'"></div>
                                    </template>
                                    <template v-else>
                                        <div class="avatar" :style="'background:' + comment.child.avatar.c">{{ comment.child.avatar.s }}</div>
                                    </template>

                                    <div class="comment-name">{{ comment.child.name }}</div>
                                    <div class="comment-date num-fa">
                                        <i class="fa fa-calendar"></i>
                                        {{ comment.child.created_at }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-xx-10 col-el-10 col-xl-10 col-lg-10 col-md-10 col-sm-9 col-tm-12 col-12 comment-text">
                                <pre class="text p-2" v-html="comment.child.text"></pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="currentPage < lastPage" class="text-center mt-3">
            <button class="btn btn-secondary btn-sm" @click.prevent="fetch(false)">دیدگاه های قدیمی تر...</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'object-comments',
    components: {},
    data() {
        let self = this;

        return {
            comments: [],
            currentPage: 0,
            lastPage: 0,
        };
    },
    props: {
        slug: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        }
    },
    computed: {
        apiUrl() {
            return this.$root.baseURL + 'api/v1/comments';
        }
    },
    methods: {
        fetch(silent) {
            let self = this;

            if (!silent) {
                //self.$root.loading = true;
            }
            axios.get(self.apiUrl, {params: {type: self.type, slug: self.slug, page: self.currentPage + 1}})
                .then((response) => {
                    response.data.comments.forEach(function (el) {
                        self.comments.push(el);
                    });
                    self.currentPage = response.data.currentPage;
                    self.lastPage = response.data.lastPage;
                    //self.$root.loading = false;
                });
        }
    },
    mounted() {
        this.fetch(true);
        //window.C = this;
    }
}
</script>
